import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight, Lightbulb } from 'lucide-react';

const GuidesSection = () => {
  return (
    <section className="py-20 px-4">
      <div className="container mx-auto">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center space-x-2 mb-4">
                <Lightbulb className="w-6 h-6 text-green-600" />
                <span className="text-sm font-semibold text-green-600 uppercase tracking-wide">Gaming Guides</span>
              </div>
              <h2 className="pb-2 text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-pink-600 to-green-600 bg-clip-text text-transparent">
                Master Online Casino Gaming
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Whether you're a seasoned player or just starting your online casino journey, our comprehensive guides 
                provide expert insights on everything from choosing the right casino to maximizing your bonuses and 
                understanding game strategies.
              </p>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                Learn how to play online casinos in the UK with confidence. Our guides cover responsible gambling practices, 
                understanding terms and conditions, game rules, payment methods, and much more. Empower yourself with knowledge 
                and make informed decisions every step of the way.
              </p>
              <Link
                to="/guides"
                className="inline-flex items-center space-x-2 px-8 py-4 bg-gradient-to-r from-pink-600 to-green-600 text-white font-semibold rounded-full hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
                data-discover="true"
              >
                <span>Explore Our Guides</span>
                <ArrowRight className="w-5 h-5" />
              </Link>
            </div>

            <div className="glass-strong p-8 rounded-3xl">
              <div className="relative h-96 bg-gradient-to-br from-pink-200 via-green-200 to-pink-300 rounded-2xl overflow-hidden" style={{ backgroundImage: 'url("/images/krissia-cruz-FwPzGn59wNs-unsplash.jpg")', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-8 left-8 right-8">
                  <div className="glass p-6 rounded-2xl">
                    <BookOpen className="w-12 h-12 text-white mb-4" />
                    <h3 className="text-2xl font-bold text-white mb-2">Expert Knowledge</h3>
                    <p className="text-white/90">
                      Comprehensive guides written by industry experts to help you navigate the world of online casinos.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuidesSection;

